import { Pipe, PipeTransform } from '@angular/core';
import { chunk } from 'lodash-es';

@Pipe({
    name: 'chunk',
    standalone: false
})
export class ChunkPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return chunk(value, args);
  }
}
